import React from 'react';
import navarrow from "../assets/back_btn.png";
import { WALLETPAGE_STRINGS } from "../Strings";
import { staticWebUrl } from '../ApiConstants.js';
import { Link } from 'react-router-dom';

class Loyalty extends React.Component {
  constructor() {
    super();
    this.state = {
      iFrameHeight: '0px',
      channel: window.sessionStorage["channel"]
    }
  }

  handlebackbtn = () => {
    sessionStorage.setItem("fromScreen","wallet")
    this.props.history.push("/walletinfo/")
    return
  }

  componentDidMount() {

  }
  render() {

    return (
      <div className="bg-white center">

        <nav className='navbar'>
          <div className="nav-container" >
            {/* <Link to="/walletinfo/"> */}
            <img
              className='backBtn'
              src={navarrow}
              style={{ width: "40px" }}
              onClick={() => this.handlebackbtn()}
            />
            {/* </Link> */}
            <p className="nav-text" style={{ textAlign: 'center' }}>Loyalty Program</p>
            <div></div>
          </div>
        </nav>



        {/* <div className="ph2 ph6-l f6 f4-l f5-ns tc center bg-white" style={{ height:"100%",width:"100%",paddingTop: "3rem", overflow:"hidden"}} height="100%" width="100%"> */}

        {(this.state.channel == "HPS" || this.state.channel == "hps" || this.state.channel == "A23HPS") ? <div>
          {/* pl-3827 */}
          <iframe style={{ marginTop: "2px", marginBottom: "2px", height: "100vh", width: "100%", overflowY: "scroll",overflowX:"hidden" }} height="100vh" width="100%" title="" frameBorder="0px" overflowY="scroll" src={process.env.REACT_APP_PLAY_STATIC_WEB_URL + "acepoints.html?src=mapp&platformapp=Y&header=N"} >
          </iframe>
        </div> : <div>
          <iframe style={{ marginTop: "2px", marginBottom: "2px", height: "100vh", width: "100%", overflowY: "scroll",overflowX:"hidden" }} height="100vh" width="100%" title="" frameBorder="0px" overflowY="scroll" src={process.env.REACT_APP_REAL_STATIC_WEB_URL + "acepoints.html?src=mapp&platformapp=Y&header=N"} >
          </iframe>
        </div>}
        {/* </div> */}
      </div>

    );
  }
}
export default Loyalty;